import src from "IMAGE";
export default { src, width: 840, height: 244, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42hXLUQqAQAgA0T1HhyyUBMEQW8nEU687328GIl4R4Zn5ddPdDQBOVZWq+sfREREy8y0i3ODd2MyeHucC4pweIhKnqQ0AAAAASUVORK5CYII="};
